export const skillData = [
  {
    className: "devicon-javascript-plain",
    label: "Javascript",
  },
  {
    className: "devicon-typescript-plain",
    label: "Typescript",
  },
  {
    className: "devicon-react-original",
    label: "React",
  },
  {
    className: "devicon-nodejs-plain",
    label: "Nodejs",
  },
  {
    className: "devicon-express-original",
    label: "Express",
  },
  {
    className: "devicon-graphql-plain",
    label: "GraphQL",
  },
  {
    className: "devicon-redux-original",
    label: "Redux",
  },

  {
    className: "devicon-cplusplus-plain",
    label: "C++",
  },
  {
    className: "devicon-c-plain",
    label: "C",
  },
  {
    className: "devicon-python-plain",
    label: "Python",
  },

  {
    className: "devicon-flask-original",
    label: "Flask",
  },
  {
    className: "devicon-mysql-plain",
    label: "MySQL",
  },
  {
    className: "devicon-mongodb-plain",
    label: "MongoDB",
  },
  {
    className: "devicon-postgresql-plain",
    label: "PostgreSQL",
  },
  {
    className: "devicon-neo4j-plain",
    label: "Neo4j",
  },

  {
    className: "devicon-bash-plain",
    label: "Bash",
  },
  {
    className: "devicon-linux-plain",
    label: "Linux",
  },
  {
    className: "devicon-elixir-plain",
    label: "Elixir",
  },
  {
    className: "devicon-docker-plain",
    label: "Docker",
  },
  {
    className: "devicon-kubernetes-plain",
    label: "Kubernetes",
  },
  {
    className: "devicon-amazonwebservices-original",
    label: "AWS",
  },
  {
    className: "devicon-nginx-original",
    label: "Nginx",
  },
  {
    className: "devicon-git-plain",
    label: "Git",
  },
  {
    className: "devicon-bootstrap-plain",
    label: "Bootstrap",
  },
];
